/**
 * Charte des contrôles de formulaire.
 * Bordure grise au repos, bleu Chronoflex au focus, sans ombre et sans encoche.
 * Le bleu est celui des maquettes : #41A1FF (blue-chronoflex-500).
 */
const focusBorder = "focus:!border-[#41A1FF]";
const fullBorder = "border-gray-300 focus:!border-[#41A1FF]";

const noNotch = {
  before: { content: "before:content-none" },
  after: { content: "after:content-none" },
};

export const materialTheme = {
  input: {
    styles: {
      variants: {
        outlined: {
          base: {
            input: {
              floated: {
                borderWidth: "border",
                borderColor: fullBorder,
              },
              placeholder: "placeholder:opacity-100",
            },
            label: noNotch,
          },
          colors: {
            input: {
              gray: {
                borderColorFocused: focusBorder,
              },
              blue: {
                borderColorFocused: focusBorder,
              },
            },
          },
          shrink: {
            input: {
              borderTop: "!border-t-gray-300 focus:!border-t-[#41A1FF]",
            },
          },
        },
      },
    },
  },
  textarea: {
    styles: {
      variants: {
        outlined: {
          base: {
            textarea: {
              floated: {
                borderWidth: "border",
                borderColor: fullBorder,
              },
            },
            label: noNotch,
          },
          colors: {
            textarea: {
              gray: {
                borderColorFocused: focusBorder,
              },
              blue: {
                borderColorFocused: focusBorder,
              },
            },
          },
          shrink: {
            textarea: {
              borderTop: "!border-t-gray-300 focus:!border-t-[#41A1FF]",
            },
          },
        },
      },
    },
  },
  select: {
    styles: {
      base: {
        option: {
          initial: {
            background: "hover:bg-[#1B7AF5] focus:bg-[#1B7AF5]",
            color: "hover:text-white focus:text-white",
          },
          active: {
            bg: "bg-[#1B7AF5]",
            color: "text-white",
          },
        },
      },
      variants: {
        outlined: {
          base: {
            label: noNotch,
          },
          states: {
            open: {
              select: {
                borderWidth: "border",
                borderColor: "border-[#41A1FF]",
              },
              label: noNotch,
            },
            withValue: {
              select: {
                borderWidth: "border",
                borderColor: "border-gray-300",
              },
              label: noNotch,
            },
          },
          colors: {
            select: {
              gray: {
                open: {
                  borderColor: "border-[#41A1FF]",
                  borderTopColor: "border-t-[#41A1FF]",
                },
                withValue: {
                  borderColor: "border-gray-300",
                  borderTopColor: "border-t-gray-300",
                },
              },
              blue: {
                open: {
                  borderColor: "border-[#41A1FF]",
                  borderTopColor: "border-t-[#41A1FF]",
                },
                withValue: {
                  borderColor: "border-gray-300",
                  borderTopColor: "border-t-gray-300",
                },
              },
            },
          },
        },
      },
    },
  },
  button: {
    styles: {
      variants: {
        outlined: {
          gray: {
            border: "border border-[#B6BAC3]",
            color: "text-gray-500",
            hover: "hover:bg-gray-50 hover:opacity-100",
            focus: "focus:ring-2 focus:ring-[#D4ECFF]",
            active: "active:bg-gray-100",
          },
        },
      },
    },
  },
  checkbox: {
    defaultProps: {
      color: "blue",
    },
    styles: {
      colors: {
        blue: {
          background: "checked:bg-[#41A1FF]",
          border: "checked:border-[#41A1FF]",
          before: "checked:before:bg-[#41A1FF]",
        },
      },
    },
  },
  radio: {
    defaultProps: {
      color: "blue",
    },
    styles: {
      base: {
        input: {
          borderColor: "border-[#B6BAC3]",
          before: {
            bg: "before:bg-[#1B7AF5]",
          },
        },
      },
      colors: {
        blue: {
          color: "text-[#1B7AF5]",
          border: "checked:border-[#1B7AF5]",
          before: "checked:before:bg-[#1B7AF5]",
        },
      },
    },
  },
  progress: {
    defaultProps: {
      color: "blue",
    },
    styles: {
      variants: {
        filled: {
          blue: {
            backgroud: "bg-[#41A1FF]",
            color: "text-white",
          },
        },
      },
    },
  },
  spinner: {
    defaultProps: {
      color: "blue",
    },
    styles: {
      colors: {
        blue: {
          color: "text-[#41A1FF]",
        },
      },
    },
  },
};
